import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { ChartContainer, ChartConfig } from '@/components/ui/chart';
import { format } from 'date-fns';
import { ar } from 'date-fns/locale';

const chartConfig: ChartConfig = {
  cod_collected:  { label: 'COD محصّل',    color: 'hsl(142, 72%, 42%)' },
  delivery_fees:  { label: 'رسوم التوصيل', color: 'hsl(217, 91%, 60%)' },
};

interface Props {
  data: { date: string; cod_collected: number; delivery_fees: number }[];
}

function formatDate(d: string) {
  try { return format(new Date(d), 'd MMM', { locale: ar }); } catch { return d; }
}

function formatAmount(v: number) {
  return v >= 1000 ? `${(v / 1000).toFixed(1)}k` : String(v);
}

export function CodCollectionChart({ data }: Props) {
  if (!data.length) {
    return (
      <div className="flex items-center justify-center h-[220px] text-muted-foreground text-sm">
        لا توجد بيانات
      </div>
    );
  }

  return (
    <ChartContainer config={chartConfig} className="h-[220px] w-full">
      <BarChart data={data} margin={{ top: 4, right: 12, left: -16, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-border/40" />
        <XAxis dataKey="date" tickFormatter={formatDate} tick={{ fontSize: 11 }} />
        <YAxis tickFormatter={formatAmount} tick={{ fontSize: 11 }} />
        <Tooltip
          contentStyle={{ background: 'hsl(var(--background))', border: '1px solid hsl(var(--border))', borderRadius: 8, fontSize: 12 }}
          formatter={(v: any, name: string) => [Number(v).toLocaleString(), chartConfig[name]?.label ?? name]}
          labelFormatter={formatDate}
        />
        <Legend formatter={(name) => chartConfig[name]?.label ?? name} wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
        <Bar dataKey="cod_collected" stackId="a" fill="var(--color-cod_collected)" radius={[0, 0, 0, 0]} />
        <Bar dataKey="delivery_fees" stackId="a" fill="var(--color-delivery_fees)" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ChartContainer>
  );
}
